"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpandableCellContainer = void 0;
const stitches_config_1 = require("../../../stitches.config");
exports.ExpandableCellContainer = (0, stitches_config_1.styled)("div", {
    display: "flex",
    flexDirection: "row",
    gap: "8px",
    cursor: "pointer",
    height: "100%",
    variants: {
        clickDisabled: {
            true: {
                cursor: "default",
            },
        },
        expanded: {
            true: {
                cursor: "default",
                flexDirection: "column",
                maxHeight: "168px",
                overflowY: "auto",
                padding: "8px 32px 8px 8px",
            },
        },
    },
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRXhwYW5kYWJsZUNlbGwuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9jb21wb25lbnRzL0NvbW1vbi9fX3N0eWxlc19fL0V4cGFuZGFibGVDZWxsLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLDhEQUFrRDtBQUVyQyxRQUFBLHVCQUF1QixHQUFHLElBQUEsd0JBQU0sRUFBQyxLQUFLLEVBQUU7SUFDbkQsT0FBTyxFQUFFLE1BQU07SUFDZixhQUFhLEVBQUUsS0FBSztJQUNwQixHQUFHLEVBQUUsS0FBSztJQUNWLE1BQU0sRUFBRSxTQUFTO0lBQ2pCLE1BQU0sRUFBRSxNQUFNO0lBQ2QsUUFBUSxFQUFFO1FBQ1IsYUFBYSxFQUFFO1lBQ2IsSUFBSSxFQUFFO2dCQUNKLE1BQU0sRUFBRSxTQUFTO2FBQ2xCO1NBQ0Y7UUFDRCxRQUFRLEVBQUU7WUFDUixJQUFJLEVBQUU7Z0JBQ0osTUFBTSxFQUFFLFNBQVM7Z0JBRWpCLGFBQWEsRUFBRSxRQUFRO2dCQUN2QixTQUFTLEVBQUUsT0FBTztnQkFDbEIsU0FBUyxFQUFFLE1BQU07Z0JBQ2pCLE9BQU8sRUFBRSxrQkFBa0I7YUFDNUI7U0FDRjtLQUNGO0NBQ0YsQ0FBQyxDQUFDIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgc3R5bGVkIH0gZnJvbSBcIi4uLy4uLy4uL3N0aXRjaGVzLmNvbmZpZ1wiO1xuXG5leHBvcnQgY29uc3QgRXhwYW5kYWJsZUNlbGxDb250YWluZXIgPSBzdHlsZWQoXCJkaXZcIiwge1xuICBkaXNwbGF5OiBcImZsZXhcIixcbiAgZmxleERpcmVjdGlvbjogXCJyb3dcIixcbiAgZ2FwOiBcIjhweFwiLFxuICBjdXJzb3I6IFwicG9pbnRlclwiLFxuICBoZWlnaHQ6IFwiMTAwJVwiLFxuICB2YXJpYW50czoge1xuICAgIGNsaWNrRGlzYWJsZWQ6IHtcbiAgICAgIHRydWU6IHtcbiAgICAgICAgY3Vyc29yOiBcImRlZmF1bHRcIixcbiAgICAgIH0sXG4gICAgfSxcbiAgICBleHBhbmRlZDoge1xuICAgICAgdHJ1ZToge1xuICAgICAgICBjdXJzb3I6IFwiZGVmYXVsdFwiLFxuXG4gICAgICAgIGZsZXhEaXJlY3Rpb246IFwiY29sdW1uXCIsXG4gICAgICAgIG1heEhlaWdodDogXCIxNjhweFwiLFxuICAgICAgICBvdmVyZmxvd1k6IFwiYXV0b1wiLFxuICAgICAgICBwYWRkaW5nOiBcIjhweCAzMnB4IDhweCA4cHhcIixcbiAgICAgIH0sXG4gICAgfSxcbiAgfSxcbn0pO1xuIl19